import '../sass/race-details.scss';

(() => {
    const $blocks = document.querySelectorAll('.race-details');

    $blocks?.forEach($block => {
        const $tabsContentCarousel = $block.querySelector('.race-details__tabs-content-carousel');
        const $tabsNavButtons = $block.querySelectorAll('.race-details__tabs-nav-button');
        const $detailsTabs = $block.querySelectorAll('.race-details__details-tab');

        const initDetails = () => {
            if (!$detailsTabs) return;

            $detailsTabs.forEach($detailsTab => {
                new Details($detailsTab);
            });
        };

        const initCarousel = () => {
            if (!$tabsContentCarousel) return;

            const carousel = new Swiper($tabsContentCarousel, {
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                allowTouchMove: false,
            });

            carousel.on('slideChange', () => {
                if ($tabsNavButtons) {
                    $tabsNavButtons.forEach($button => {
                        if ($button.dataset.index == carousel.activeIndex) {
                            $button.classList.add('race-details__tabs-nav-button--active');
                        } else {
                            $button.classList.remove('race-details__tabs-nav-button--active');
                        }
                    });
                }
            })

            if ($tabsNavButtons) {
                $tabsNavButtons.forEach($button => {
                    $button.addEventListener('click', e => {
                        e.preventDefault();
                        
                        carousel.slideTo($button.dataset.index);
                    });
                });
            }
        };

        initDetails();
        initCarousel();
    });
})();
